/**
 * @generated SignedSource<<a1369924c5d0590a52751ff895663f0c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PipelineListQuery$variables = {
  locator: string;
};
export type PipelineListQuery$data = {
  readonly projectsRest: {
    readonly project: ReadonlyArray<{
      readonly buildTypes: {
        readonly buildType: ReadonlyArray<{
          readonly internalId: string | null;
          readonly parameters: {
            readonly property: ReadonlyArray<{
              readonly name: string | null;
            }> | null;
          } | null;
        }> | null;
      } | null;
      readonly internalId: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"PipelineLineProjectFragment">;
    }> | null;
  } | null;
};
export type PipelineListQuery = {
  response: PipelineListQuery$data;
  variables: PipelineListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "locator",
    "variableName": "locator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Properties",
  "kind": "LinkedField",
  "name": "parameters",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Property",
      "kind": "LinkedField",
      "name": "property",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "internalId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PipelineListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Projects",
        "kind": "LinkedField",
        "name": "projectsRest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectRest",
            "kind": "LinkedField",
            "name": "project",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BuildTypes",
                "kind": "LinkedField",
                "name": "buildTypes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BuildTypeRest",
                    "kind": "LinkedField",
                    "name": "buildType",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PipelineLineProjectFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PipelineListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Projects",
        "kind": "LinkedField",
        "name": "projectsRest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectRest",
            "kind": "LinkedField",
            "name": "project",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BuildTypes",
                "kind": "LinkedField",
                "name": "buildTypes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BuildTypeRest",
                    "kind": "LinkedField",
                    "name": "buildType",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "locator",
                            "value": "count:1,state:any"
                          }
                        ],
                        "concreteType": "Builds",
                        "kind": "LinkedField",
                        "name": "builds",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Build",
                            "kind": "LinkedField",
                            "name": "build",
                            "plural": true,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "state",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "startEstimate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "finishDate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "status",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "parallelized",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Comment",
                                "kind": "LinkedField",
                                "name": "canceledInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "timestamp",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "failedToStart",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "statusText",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "waitReason",
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "builds(locator:\"count:1,state:any\")"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "029cd4bcdeac6c05115c8466bfbb3c6f",
    "id": null,
    "metadata": {},
    "name": "PipelineListQuery",
    "operationKind": "query",
    "text": "query PipelineListQuery(\n  $locator: String!\n) {\n  projectsRest(locator: $locator) {\n    project {\n      buildTypes {\n        buildType {\n          parameters {\n            property {\n              name\n            }\n          }\n          internalId\n          id\n        }\n      }\n      internalId\n      ...PipelineLineProjectFragment\n      id\n    }\n  }\n}\n\nfragment PipelineLineLastRunFragment on ProjectRest {\n  buildTypes {\n    buildType {\n      builds(locator: \"count:1,state:any\") {\n        build {\n          rawId\n          state\n          startEstimate\n          finishDate\n          ...RunStatusFragment\n          ...useRunningBuildUpdaterRelayFragment\n          id\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment PipelineLineProjectFragment on ProjectRest {\n  ...pipelineHeadFragment\n  ...PipelineLineLastRunFragment\n}\n\nfragment RunStatusFragment on Build {\n  rawId\n  status\n  state\n  parallelized\n  canceledInfo {\n    timestamp\n  }\n  failedToStart\n  statusText\n  waitReason\n  startEstimate\n}\n\nfragment pipelineHeadFragment on ProjectRest {\n  buildTypes {\n    buildType {\n      rawId\n      internalId\n      parameters {\n        property {\n          name\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment useRunningBuildUpdaterRelayFragment on Build {\n  id\n  rawId\n  state\n}\n"
  }
};
})();

(node as any).hash = "ec257b82b64dcda76377383fda133d38";

export default node;
